<template>
  <div class="tes-card pa-7">
    <h1 class="tes-card__title">Контакты</h1>

    <label class="personal-account">
      <span class="personal-account__title">Лицевой счет:</span>
      <personal-account-select></personal-account-select>
    </label>

    <ul class="contacts__container">
      <li
        class="contacts__info-block"
        v-for="item in contacts.contacts"
        :key="item.title">
        <h2 class="contacts__title-2">{{item.serviceName}}:</h2>

        <v-divider class="divider"></v-divider>

        <div class="content">
          <div class="content-block content-block--left">
            <div class="content-block__piece">
              <h3 class="content-block__title">{{item.officeName}}</h3>
              <address class="content-block__text">{{item.address}}</address>
            </div>
            <div class="content-block__piece">
              <h3 class="content-block__title">Начальник</h3>
              <span>{{item.headFio}}</span>
            </div>
          </div>

          <div class="content-block content-block-right">
            <div class="content-block__piece">
              <h3 class="content-block__title">График работы</h3>
              <div v-for="(scheduleItem, index) in (item.schedules.split(', '))" :key="index">
                <span class="content-block__schedule">{{scheduleItem}}</span>
                <br>
              </div>
            </div>

            <div class="content-block__piece">
              <h3 class="content-block__title">Телефоны</h3>
              <template v-for="(tel, index) in item.phoneNumbers">
                <a class="content-block__link" :href="`tel:${tel}`" :key="index">{{tel}}</a>
                <br :key="'br-' + index">
              </template>
            </div>

            <div v-if="item.fax && item.fax.length > 0" class="content-block__piece">
              <h3 class="content-block__title">Факс</h3>
              <a class="content-block__link" v-for="(fax, index) in item.fax" :href="`tel:${fax}`"
                 :key="index">{{fax}}</a>
            </div>
          </div>
        </div>
      </li>
      <li v-if="!contacts.contacts || !contacts.contacts.length" class="caption grey--text">
        Для этого лицевого счета нет офисов обслуживания
      </li>
    </ul>
  </div>
</template>

<script>
  import PersonalAccountSelect from "@/components/common/PersonalAccountSelect.vue";
  import {
    mapState
  } from "vuex";

  export default {
    components: {
      PersonalAccountSelect
    },
    layout: "main",
    computed: {
      ...mapState("feedback", ["contacts"]),
      ...mapState("account", ["selectedAccount"])
    },
    watch: {
      selectedAccount: {
        immediate: true,
        handler: function (value) {
          this.$store.dispatch("feedback/getContacts", {
            "domHoz": value.domHoz
          });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .contacts {
    background: white;
    width: 100%;
    position: relative;
    padding: 23px 17px 23px 22px;
    border-radius: 5px;

    &__title {
      @extend %h1;
      margin-bottom: 4px;
    }

    &__container {
      margin: 0;
      padding: 0;
      list-style-type: none;
    }

    &__info-block {
      & + & {
        margin-top: 35px;
      }
    }

    &__title-2 {
      @extend %h2;
      margin-top: 4px;
      margin-bottom: 11px;
    }
  }

  .personal-account {
    display: inline-block;
    margin: 35px 0;

    &__title {
      @extend %important-text;
      display: inline-block;
      margin-bottom: 10px;
    }
  }

  .divider {
    margin: 0;
    border-color: #b1b3b4;
  }

  .content {
    display: flex;

    @media screen and (max-width: 414px) {
      flex-direction: column;
    }
  }

  .content-block {
    position: relative;

    &--left {
      width: 70%;
      position: relative;
    }

    &--right {
      width: 30%;
      position: relative;
    }

    &__piece {
      margin-top: 25px;
      width: 100%;
    }

    &__title {
      @extend %h3;
    }

    &__text {
      @extend %text;
    }

    &__link {
      @extend %link;
      display: inline-block;
    }

    &__schedule {
      @extend %text;
      font-style: italic;
    }
  }
</style>
